/* pd-r15 — Apple design pass (17 Oct 2026).
   1. Lazy images whose first load was cut off get one retry, so no thumbnail stays blank.
   2. Menu, bag and filter drawers follow the finger and can be flicked closed. */
(function () {
  'use strict';

  /* ---------- 1. Thumbnail safety net ---------- */
  function healImages() {
    document.querySelectorAll('.lazy-image img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.parentNode.classList.add('lazyloaded');
        return;
      }
      // stuck: either the load failed, or a lazy load never started (no source picked yet)
      var stuck = img.complete || !img.currentSrc;
      if (!stuck || img.dataset.pdR15Retry) return;
      var r = img.getBoundingClientRect();                         // only images on screen; leave real lazy ones alone
      if (!r.width || r.bottom < 0 || r.top > innerHeight) return;
      img.dataset.pdR15Retry = '1';
      img.loading = 'eager';
      var s = img.getAttribute('srcset');
      if (s) { img.removeAttribute('srcset'); img.setAttribute('srcset', s); }
      else if (img.src) { var u = img.src; img.src = ''; img.src = u; }
      img.addEventListener('load', function () {
        img.parentNode.classList.add('lazyloaded');
        img.classList.add('pd-r15-shown');
      }, { once: true });
    });
  }
  if (document.readyState === 'complete') healImages();
  else window.addEventListener('load', healImages);
  setTimeout(healImages, 1500);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-gallery, .product-gallery__thumbnails-holder')) setTimeout(healImages, 300);
  });

  /* ---------- 2. Drag and flick drawers closed ---------- */
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var SLOP = 10;                 // px of movement before we decide the direction
  var DECEL = 0.998;             // Apple's normal deceleration rate
  function project(v) { return (v / 1000) * DECEL / (1 - DECEL); }
  function rubber(over, dim) { var c = 0.55; return (over * dim * c) / (dim + c * Math.abs(over)); }

  function axisFor(el) {
    if (el.id === 'site-filters-sidebar') return { axis: 'y', sign: 1 };          // bottom sheet: drag down
    if (el.classList.contains('sidebar--left')) return { axis: 'x', sign: -1 };   // menu: drag left
    if (el.classList.contains('sidebar--right')) return { axis: 'x', sign: 1 };   // bag: drag right
    return null;
  }
  function inHorizontalScroller(t, el) {
    for (var n = t; n && n !== el; n = n.parentElement) {
      if (n.tagName === 'CSS-SLIDER') return true;
      var cs = getComputedStyle(n);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && n.scrollWidth > n.clientWidth + 2) return true;
    }
    return false;
  }
  function inScrolledList(t, el) {
    for (var n = t; n && n !== el; n = n.parentElement) if (n.scrollTop > 0) return true;
    return false;
  }

  var g = null; // the active gesture

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' || g) return;
    var el = e.target.closest('sidebar-drawer.sidebar--opened');
    if (!el) return;
    var a = axisFor(el);
    if (!a) return;
    if (a.axis === 'x' && inHorizontalScroller(e.target, el)) return;
    if (a.axis === 'y' && inScrolledList(e.target, el)) return;
    var r = el.getBoundingClientRect();
    g = {
      el: el, a: a, id: e.pointerId, x0: e.clientX, y0: e.clientY,
      size: a.axis === 'x' ? r.width : r.height, live: false, d: 0,
      hist: [{ t: e.timeStamp, p: a.axis === 'x' ? e.clientX : e.clientY }],
      overlay: document.querySelector('.site-overlay')
    };
  }, { passive: true });

  document.addEventListener('pointermove', function (e) {
    if (!g || e.pointerId !== g.id) return;
    var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
    var main = g.a.axis === 'x' ? dx : dy, cross = g.a.axis === 'x' ? dy : dx;
    if (!g.live) {
      if (Math.abs(main) < SLOP && Math.abs(cross) < SLOP) return;
      if (Math.abs(cross) > Math.abs(main)) { g = null; return; }   // it's a scroll, let it be
      g.live = true;
      g.base = main;                                               // start from here: no jump
      try { g.el.setPointerCapture(g.id); } catch (_) {}
      g.el.classList.add('pd-r15-dragging');
      if (g.overlay) g.overlay.classList.add('pd-r15-dragging');
    }
    var d = (main - g.base) * g.a.sign;                            // + = towards closed
    if (d < 0) d = -rubber(-d, g.size);                            // soft resistance the other way
    g.d = d;
    var p = g.a.axis === 'x' ? e.clientX : e.clientY;
    g.hist.push({ t: e.timeStamp, p: p });
    if (g.hist.length > 6) g.hist.shift();
    var off = d * g.a.sign;
    g.el.style.setProperty('transform', g.a.axis === 'x' ? 'translateX(' + off + 'px)' : 'translateY(' + off + 'px)', 'important');
    if (g.overlay) g.overlay.style.setProperty('opacity', String(Math.max(0, 1 - Math.max(0, d) / g.size)), 'important');
  }, { passive: true });

  function finish(e) {
    if (!g || e.pointerId !== g.id) return;
    var s = g; g = null;
    if (!s.live) return;
    var h = s.hist, a = h[0], b = h[h.length - 1];
    var dt = Math.max(1, b.t - a.t);
    var v = ((b.p - a.p) / dt) * 1000 * s.a.sign;                  // px/s towards closed
    var close = e.type !== 'pointercancel' && (s.d + project(v) > s.size * 0.5);
    var remaining = close ? s.size - s.d : Math.abs(s.d);
    // carry the finger's speed into the finish: faster flick, shorter settle
    var dur = reduce.matches ? 0.2 : Math.min(0.36, Math.max(0.16, remaining / Math.max(Math.abs(v), 900)));
    var ease = 'cubic-bezier(0.2, 0.8, 0.2, 1)';
    s.el.classList.remove('pd-r15-dragging');
    if (s.overlay) s.overlay.classList.remove('pd-r15-dragging');
    s.el.style.setProperty('transition', 'transform ' + dur + 's ' + ease, 'important');
    if (s.overlay) s.overlay.style.setProperty('transition', 'opacity ' + dur + 's ' + ease, 'important');
    requestAnimationFrame(function () {
      s.el.style.removeProperty('transform');
      if (s.overlay) s.overlay.style.removeProperty('opacity');
      if (close) s.el.hide();
      setTimeout(function () {
        s.el.style.removeProperty('transition');
        if (s.overlay) s.overlay.style.removeProperty('transition');
      }, dur * 1000 + 60);
    });
  }
  document.addEventListener('pointerup', finish, { passive: true });
  document.addEventListener('pointercancel', finish, { passive: true });
})();
